import { gu } from "date-fns/locale";
import { CoberturaPoliza } from "../models/polizaSeguro";
import { actualizarCobertura, crearCobertura } from "../service/servicePoliza";


export function useCobertura() {
    const guardar = async (data: CoberturaPoliza, dataediting: CoberturaPoliza | undefined) => {
        let dataRequest: CoberturaPoliza = {
            polizaCodigo: data.polizaCodigo,
            polizaCodigohijo: data.polizaCodigohijo,
            codigoCobertura: data.codigoCobertura,
            tasa: data.tasa,
            prima: data.prima,

        };

        if (dataediting) {
            return await actualizarCobertura(dataRequest);
        }

        return await crearCobertura(dataRequest);
    }
    return guardar
}